import { type IThread, useApi } from '@chainlit/react-client';

import type { Artifact } from '@/components/ScheduledAgents/ArtifactShelf';
import { RunHeader } from '@/components/ScheduledAgents/RunHeader';

interface Props {
    threadId?: string;
    artifacts: Artifact[];
}

export function DeepIntelligenceRunHeader({ threadId, artifacts }: Props) {
    const { data: thread } = useApi<IThread>(
        threadId ? `/project/thread/${threadId}` : null,
        { revalidateOnFocus: false }
    );

    if (!thread) return null;

    return (
        <div className="w-full">
            <RunHeader thread={thread} artifacts={artifacts} />
        </div>
    );
}
